/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getTrains = () => {
  return progressApi.get(`/TagMeta/GetTrainsByPlantId${extractedPath}?id=${1}`);
};

export const getAllTrains = () => {
  return progressApi.get(`/TagMeta/GetAllTrains${extractedPath}`);
};

export const createTrain = (train: any) => {
  return progressApi.post(`/TagMeta/CreateTrain${extractedPath}`, train);
};

export const updateTrain = (train: any) => {
  return progressApi.post(`/TagMeta/UpdateTrain${extractedPath}`, train);
};

export const deleteTrain = (id: number) => {
  return progressApi.get(`/TagMeta/DeleteTrain${extractedPath}?id=${id}`);
};
